export default __webpack_public_path__ + "static/media/Wde.1a26ccc5.png";